module.exports = __webpack_public_path__ + "img/primera.02485b98.jpg";